// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1bVDi","actionsCol":"EnrolledClinics_actionsCol__xD5mZ"};